// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-1b23689c]{position:relative;display:flex;align-items:center;flex-direction:column;width:40vw;height:auto;margin-bottom:20px;padding:30px}.wrapper .md-table[data-v-1b23689c]{height:20vh}.wrapper .md-dialog-actions[data-v-1b23689c]{align-self:end;padding-right:30px}.wrapper .declined_text[data-v-1b23689c]{align-self:start;width:100%;margin-top:20px}.is_submitted_checkbox[data-v-1b23689c]{margin:0}", ""]);
// Exports
module.exports = exports;
